import { pageConfig } from '@/common/service/page-config';
import { BILLING_CYCLE } from '@/common/constants';
import { computedPbxBasePlans, computedCallingPlans, computedPbxUnconfigCallingPlans, computedPbxPlans, computedZoneBundlePlans } from '@/common/service/computers/plans/pbx';
import { getBasePlanInfo } from '@/common/product';
import { get } from 'lodash';

/**
 * @deprecated Use {@link getPbxBillingCycle} instead.
 *
 * Known issues:
 * 1. Billing cycle resolution is incorrectly coupled to calling plans — it
 *    prioritizes `boughtCallingPlans[0].billing_cycle` over the base plan's
 *    own cycle. When the user has no calling plans (e.g., only Toll-Free,
 *    Phone Number, or Feature add-ons), the calling plan lookup yields nothing
 *    and falls through to a fragile base-plan fallback path.
 * 2. The PAYG fallback relies on `getBasePlanInfo()` which may return stale or
 *    mismatched data, rather than directly filtering base plans by renewable
 *    billing cycles.
 */
export function getPbxBillingCycleLegacy(boughtPlans = []) {
  const { period = BILLING_CYCLE.ANNUAL } = pageConfig;
  const boughtPbxBasePlans = computedPbxBasePlans(boughtPlans);
  //zp pro and common area special billing cycle not be configured by plan json api yet
  const UnconfigCallingPlans = computedPbxUnconfigCallingPlans(boughtPlans);
  const boughtCallingPlans = computedCallingPlans(boughtPlans).concat([...UnconfigCallingPlans]);

  // default load pbx billing cycle, if has bought base plan, choose base plan cycle
  const basePlanBillingCycle = get(boughtPbxBasePlans, [0, 'billing_cycle']);
  const isPayAsYouGo = basePlanBillingCycle === BILLING_CYCLE.PAY_AS_YOU_GO;
  const basePlan = get(getBasePlanInfo(), 'plans.0', {});
  const billingCycle = get(
    boughtCallingPlans,
    [0, 'billing_cycle'],
    isPayAsYouGo ? basePlan.billing_cycle || period : basePlanBillingCycle || period,
  );
  return billingCycle;
}

const RENEWABLE_BILLING_CYCLES = [
  BILLING_CYCLE.MONTHLY,
  BILLING_CYCLE.QUARTERLY,
  BILLING_CYCLE.ANNUAL,
  BILLING_CYCLE.TWO_YEARS,
  BILLING_CYCLE.THREE_YEARS,
];

export default function getPbxBillingCycle(boughtPlans = []) {
  const { period = BILLING_CYCLE.ANNUAL } = pageConfig;
  const allPhonePlans = [...computedPbxPlans(boughtPlans), ...computedZoneBundlePlans(boughtPlans)];
  const renewablePlan = allPhonePlans.find(
    plan => RENEWABLE_BILLING_CYCLES.includes(plan.billing_cycle),
  );
  return get(renewablePlan, 'billing_cycle', period);
}

export const getPbxCurrentBillingCycle = (pbxBasePlan, nonPbxBasePlan, defaultBillingCycle = BILLING_CYCLE.ANNUAL) => {
  if (!pbxBasePlan) return;

  if (nonPbxBasePlan) {
    return nonPbxBasePlan?.billing_cycle;
  }

  if (pbxBasePlan?.is_payg) {
    return defaultBillingCycle;
  }

  return pbxBasePlan?.billing_cycle;
}
